import { useSafeAreaInsets } from 'react-native-safe-area-context';

// Base height of the absolute "Powered by" Footer (see Footer.tsx).
export const FOOTER_BASE_HEIGHT = 35;

/**
 * Height the bottom Footer occupies, including the bottom safe-area inset.
 */
export function useFooterHeight(): number {
	const insets = useSafeAreaInsets();
	return FOOTER_BASE_HEIGHT + insets.bottom;
}
